import ContratoInterceptor from '../ContratoInterceptor'
import { Procedimento } from '../../../types/Contratos'

const api = new ContratoInterceptor()

export default {
  addProcedimentos(contratoId: String, grupoRemuneracaoId: String, procedimentos: Procedimento[]) {
    return api.post(`/contratos/${contratoId}/grupos-remuneracao/${grupoRemuneracaoId}/procedimentos`, procedimentos)
  },

  deleteProcedimento(contratoId: String, grupoRemuneracaoId: String, codigo: String) {
    return api.delete(`/contratos/${contratoId}/grupos-remuneracao/${grupoRemuneracaoId}/procedimentos/${codigo}/`)
  },

  deleteProcedimentoExcecao(contratoId: String, procedimentoId: String) {
    return api.delete(`/contratos/${contratoId}/procedimentos-excecao/${procedimentoId}`)
  },

  getProcedimentosExcecao(contratoId: String) {
    return api.get(`/contratos/${contratoId}/procedimentos-excecao`)
  },

  getProcedimentosGruposRemuneracao(grupoRemuneracaoId: String) {
    return api.get(`/contratos/grupos-remuneracao/${grupoRemuneracaoId}/procedimentos`)
  },

  getProcedimentosTabelaReferencia(tabelaReferenciaId: String, CbosIds: String, tabelaPorteId: String, fontePagadoraId: String) {
    return api.get(`/procedimentos-referencia?TabelaReferenciaId=${tabelaReferenciaId}&${CbosIds}TabelaPorteId=${tabelaPorteId}&FontePagadoraId=${fontePagadoraId}`)
  },

  getProcedimentosByContrato(contratoId: String, ContratoGrupoRemuneracaoId: String, LocalExecucaoId: String, OperadoraId: String, PlanoOperadoraId: String) {
    return api.get(`/procedimentos?ContratoId=${contratoId}&ContratoGrupoRemuneracaoId=${ContratoGrupoRemuneracaoId}&LocalExecucaoId=${LocalExecucaoId}&OperadoraId=${OperadoraId}&PlanoOperadoraId=${PlanoOperadoraId}`)
  },

  getProcedimentosProvisaoByProcedimentoId(procedimentoId: String) {
    return api.get(`/procedimentoProvisao/${procedimentoId}`)
  },

  updateProcedimentosExcecao(contratoId: String, procedimentos: any) {
    return api.post(`/contratos/${contratoId}/procedimentos-excecao`, procedimentos)
  },

  updateProcedimentosGruposRemuneracao(contratoId: String, grupoRemuneracaoId: String, procedimentos: Procedimento[]) {
    return api.post(`/contratos/${contratoId}/grupos-remuneracao/${grupoRemuneracaoId}/procedimentos`, procedimentos)
  },
}
